<template>
    <b-modal ref="modal-view-detail" :centered="true" :scrollable="true" :title="title" class="modal-contract-detail" hide-footer
             size="xl" @hide="onHide">
        <div class="d-block text-center">
            <ValidationObserver ref="form">
                <form class="form">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Họ và tên</label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Họ và tên"
                                                            rules="required|min:6" vid="name">
                                            <el-input :class="classes" :value="contract_detail.customer? contract_detail.customer?.name : contract_detail.user?.name" disabled
                                                      name="name"
                                                      placeholder="Họ và tên học viên"
                                                      type="text"/>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label>Số điện thoại</label>
                                        <ValidationProvider v-slot="{ errors,classes }" :rules="{ required: true,regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                                                            name="Số điện thoại"
                                                            vid="phone">

                                            <el-input :class="classes" :value="contract_detail.customer ? contract_detail.customer?.phone : contract_detail.user?.phone"
                                                      disabled="disabled"
                                                      type="number"/>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Email" rules="required|email"
                                                            vid="email">
                                            <el-input :class="classes" :value="contract_detail.customer ? contract_detail.customer?.email : contract_detail.user?.email" disabled="disabled"
                                                      name="email"
                                                      placeholder="Email"
                                                      type="email"/>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label>Ngày tháng năm sinh</label>
                                        <el-date-picker id="birthDay"
                                                        ref="birthday"
                                                        :value="contract_detail.customer ? contract_detail.customer?.ngay_sinh : contract_detail.user?.profile?.birthday"
                                                        default-value="2000-10-10"
                                                        disabled format="dd-MM-yyyy" name="birthday"
                                                        placeholder="Ngày sinh"
                                                        style="width: 100%;"
                                                        type="date"
                                                        value-format="dd-MM-yyyy"
                                        ></el-date-picker>
                                    </div>
                                </div>
                            </div>
                            <course-class v-for="(course_info,index) in contract_detail.student_register_courses"
                                          :key="index"
                                          :branchs="branchs"
                                          :center_classes="center_classes"
                                          :condition_courses="condition_courses"
                                          :course_info="course_info"
                                          :courses="courses"
                                          :courses-refund="coursesRefund"
                                          :disable="true"
                                          :index="index"
                                          :is-transferred="is_transferred"
                                          @deleteCourse="deleteCourse"
                                          @selectClass="selectClass"
                                          @selectCourse="selectCourse"
                            >
                            </course-class>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Căn cước công dân
                                            <span class="text-danger"></span></label>
                                        <el-input v-model="contract_detail.user.profile.cccd" disabled="disabled"
                                                  placeholder="Căn cước công dân"
                                                  type="text"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Địa chỉ
                                            <span class="text-danger"></span></label>
                                        <el-input :value="contract_detail.customer.address ? contract_detail.customer.address : contract_detail.user.profile.address" disabled="disabled"
                                                  placeholder="Địa chỉ"
                                                  type="text"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Trung tâm:
                                            <span class="text-danger"></span></label>
                                        <el-input v-model="contract_detail.center.name" disabled="disabled" placeholder="Tên trung tâm"
                                                  type="text"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Chi nhánh:
                                            <span class="text-danger"></span></label>
                                        <el-input :value="contract_detail.branch ? contract_detail.branch.name: ''" disabled="disabled"
                                                  placeholder="Tên chi nhánh"
                                                  type="text"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Hình thức đóng học phí:
                                            <span class="text-danger"></span></label>
                                        <el-input :value="contract_detail.tuition_payment ? contract_detail.tuition_payment.name : ''" disabled="disabled"
                                                  placeholder="Hình thức đóng học phí"
                                                  type="text"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 mt-lg-0 mt-3">
                            <!-- Khóa học đã chọn -->
                            <div class="example-preview ">
                                <h4 class="mb-3" style="font-weight: 700">Khóa học đã chọn</h4>
                                <b-button id="button_show_value" v-b-toggle.list-chosen-courses class="m-1 m-0"
                                          @click="changeChervon">Chi tiết khóa học <i class="fas fa-chevron-down"></i>
                                </b-button>
                                <b-collapse id="list-chosen-courses">
                                    <table class="table table-vertical-center">
                                        <tbody>
                                        <tr v-for="(course_infor,index) in contract_detail.student_register_courses"
                                            :key="index">
                                            <td>{{ course_infor.course.name }}</td>
                                            <td width="25%">{{ coursePrice[index] | toThousandFilter }} ₫</td>
                                            <td>{{ course_infor.course_sale }} %</td>
                                            <td>
                                                {{
                                                    parseInt(course_infor.course_fee) * (1 - parseInt(course_infor.course_sale) / 100) | toThousandFilter
                                                }}
                                                ₫
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </b-collapse>
                                <div class="row pt-1">
                                    <div class="col-md-6 pl-1">
                                        <strong>Tổng giá khóa (1)</strong>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <strong>{{ totalCourseRegisterFee | toThousandFilter }} ₫</strong>
                                    </div>
                                </div>
                            </div>
                            <!-- Chi tiết thanh toán -->
                            <div class="payment-detail pt-5">
                                <div>
                                    <h4 class="mb-3" style="font-weight: 700">Chi tiết thanh toán</h4>
                                </div>
                                <b-button v-b-toggle.payment-contract-detail class="m-1 m-0  button_show_value"
                                          @click="changeChervonPromotion">Chi tiết khuyến mại <i
                                    class="fas fa-chevron-down"></i></b-button>
                                <b-collapse id="payment-contract-detail">
                                    <div v-for="(voucher,index) in vouchersForContract" v-if="vouchersForContract.length > 0"
                                         :key="index" class="row">
                                        <div class="col-4">
                                            <p>Voucher {{ ++index }}:</p>
                                        </div>
                                        <div class="col-4">
                                            <span v-if="voucher.type !== 0" class="promotion-list"><strong>{{
                                                    'Quy đổi quà tặng - ' + voucher.name
                                                }}</strong></span>
                                            <span v-else
                                                  class="promotion-list"><strong>{{ voucher.name }}</strong></span>
                                        </div>
                                        <div class="col-4">
                                            <strong v-if="voucher.unit === 1 "
                                                    class="text-danger">{{ voucher.value | toThousandFilter }}
                                                ₫</strong>
                                            <strong v-else class="text-danger">{{ voucher.value }} %</strong>
                                        </div>
                                    </div>
                                </b-collapse>
                                <div class="row border-custom p-3">
                                    <div class="col-md-6 pb-2">
                                        <strong>Tổng khuyến mại (2)</strong>
                                    </div>
                                    <div class="col-md-6 pb-2 text-right">
                                        <strong>{{ totalDiscount | toThousandFilter }} ₫</strong>
                                    </div>

                                    <!-- Gói dịch vụ bảo hành: -->
                                    <template v-if="isShowWarrantySummary">
                                        <div class="col-12 pb-2">
                                            <strong>Gói dịch vụ bảo hành</strong>
                                        </div>
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-md-6 d-flex align-items-center">
                                                    <i class="el-icon-menu mr-2"></i>
                                                    <strong>{{ contract.service.name }}</strong>
                                                </div>
                                                <div class="col-md-6 text-right">
                                                    <strong>{{ warrantyServiceAmount | formatVND }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="totalDestroyFee > 0" class="col-md-6 pb-2">
                                        <strong>Phí hủy khóa
                                            <span>(3)</span>
                                        </strong>
                                    </div>
                                    <div v-if=" totalDestroyFee > 0" class="col-md-6 text-right">
                                        <strong>{{ totalDestroyFee | toThousandFilter }} ₫</strong>
                                    </div>
                                    <div v-if="is_transferred" class="col-md-6 pb-2">
                                        <strong>Khuyến mại sau thay đổi</strong>
                                    </div>
                                    <div v-if="is_transferred" class="col-md-6 text-right">
                                        <strong>{{ totalPromotionAfterTransferred | toThousandFilter }} ₫</strong>
                                    </div>
                                </div>
                                <div class="row p-3">
                                    <div class="col-md-8 pb-2">
                                        <strong>Tổng giá trị hợp đồng
                                            <span>{{ totalDestroyFee > 0 ? '(4)' : '(3)' }}
                                                <i v-tooltip="totalDestroyFee > 0 ? '(4) = (1) - (2) + (3)' : '(3) = (1) - (2)'" class="fas fa-info-circle"
                                                   style="cursor: pointer; color: #3a8ee6"></i>
                                            </span>
                                        </strong>
                                        <span @click="collapse_detail = !collapse_detail">
                                            <i :class="{'fa-chevron-down': !collapse_detail, 'fa-chevron-up': collapse_detail}"
                                               class="fas pl-2"
                                               style="cursor: pointer;  font-size: 12px;"></i>
                                        </span>
                                    </div>
                                    <div class="col-md-4 pb-2 text-right">
                                        <strong v-if="totalDestroyFee > 0">{{ totalPriceContract | toThousandFilter }}
                                            ₫</strong>
                                    </div>
                                    <div v-if="collapse_detail" class="col-md-12 pb-2 mt-2">
                                        <div>Giá khoá học sau khuyến mại</div>
                                        <div>
                                            <ul class="ml-6">
                                                <li v-for="(course_info,index) in courseList" :key="index">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div> {{ course_info.course.name }}</div>
                                                        <div class="pr-6 pl-2 py-2 border bg-white my-1"
                                                             style="width: 50%; border-radius: 6px; text-align: right;">
                                                            {{
                                                                course_info.course_fee_discount_proxy | toThousandFilter
                                                            }} ₫
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-6 text-center">
                                        <strong>Đã thanh toán
                                            <span>{{ totalDestroyFee > 0 ? '(5)' : '(4)' }}</span>
                                        </strong>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <strong>{{ totalPaidAmount | toThousandFilter }} ₫</strong>
                                    </div>

                                    <div class="col-md-6 pt-2">
                                        <strong>Còn nợ
                                            <span v-if="isWithdrawWithCourse"> {{ totalDestroyFee > 0 ? '(6)' : '(5)' }}
                                                <i v-tooltip="totalDestroyFee > 0 ? '(6) = (4) - (5) ' : '(5) = (3) - (4)'" class="fas fa-info-circle"
                                                   style="cursor: pointer; color: #3a8ee6"></i>
                                            </span>
                                        </strong>
                                    </div>
                                    <div class="col-md-6 pt-2 text-right">
                                        <strong>{{ remainingDebtAmount | toThousandFilter }}
                                            ₫</strong>
                                    </div>
                                </div>
                            </div>
                            <div v-if="is_edutalk && gift_select.length" class="payment-detail pt-5 table-responsive">
                              <div><h4 class="mb-3" style="font-weight: 700">Quà tặng</h4></div>
                              <div
                                  v-for="gift in gift_select"
                                  :key="gift.id"
                                  class="d-flex align-items-center mb-2"
                              >
                                <div class="w-100">
                                  <b-button
                                      class="m-1 m-0 button_show_value"
                                      :id="`gift-${gift.id}`"
                                      v-b-toggle="`payment-gift-detail-${gift.id}`"
                                  >
                                    {{ gift.name }} <i class="fas fa-chevron-down"></i>
                                  </b-button>
                                  <b-collapse :id="`payment-gift-detail-${gift.id}`">
                                    <p v-html="gift.description" class="mt-3 pl-2 ml-3 font-weight-bold"></p>
                                  </b-collapse>
                                </div>
                              </div>
                            </div>
                            <div class="payment-information">
                                <payment-information :gift-data="giftData"
                                                     :is_edutalk="is_edutalk" :refund-data="refundData"
                                                     :subcontracts="contract_detail.subcontracts"></payment-information>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </div>
        <footer class="modal-footer">
            <button class="btn btn-secondary" type="button" @click="hideViewModal">Đóng</button>
        </footer>
        <list-course-refund :list-courses-refund="coursesRefund" :show-modal="showModalListCourses"
                            @clicked="closeModalListCourses"></list-course-refund>
    </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CourseClass from "./CourseClass";
import {LIST_COURSE_REFUND} from "@/core/services/store/contract/contracts.module";
import PaymentInformation from "./modal-contract/PaymentInformation";
import ListCourseRefund from "./modal-contract/ListCourseRefund";
import "@/assets/sass/contract/contractForm.scss";
import {GET_CLASSES} from "@/core/services/store/course/classes.module";
import {GET_COURSES} from "@/core/services/store/course/course.module";
import {GET_LIST_BRANCHES} from "../../../core/services/store/center/branch.module";
import { isWarrantyServiceCenter } from "@/core/config/center/centerOption";

const _ = require('lodash');

export default {
    components: {
        Multiselect,
        CourseClass,
        PaymentInformation,
        ListCourseRefund,
    },
    props: {
        showModal: {type: Boolean, default: false},
        contract: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    name: "ContractForm",
    data() {
        return {
            title: '',
            /* recalculate when action */
            recalculate: 1,
            recalculateSubTotal: 1,
            check_general: false,
            totalCourseRefundFee: 0,
            totalDestroyFee: 0,
            totalContractAmount: 0,
            totalRootDiscount: 0,
            totalWithdrawWithinCourse: 0,
            totalCourseRegisterFee: 0,
            totalDiscountByVoucher: 0,
            totalValueOfVoucher: 0,
            totalDiscount: 0,
            coursesRefund: [],
            coursePrice: [],
            refundData: [],
            giftData: [],
            isWithdrawWithCourse: false,
            /* detail variable */
            contract_detail: {
                customer: {
                    ngay_sinh: ''
                },
                user: {
                    id: '',
                    name: '',
                    phone: '',
                    email: '',
                    profile: {
                        address: '',
                        cccd: ''
                    },
                },
                center: {name: ''},
                branch: {name: ''},
                student_register_courses: [{
                    id: '',
                    contract_id: '',
                    course_id: '',
                    class_id: '',
                    course_fee: '',
                    course_sale: '',
                    dang_ky_ho: '',
                    xac_nhan: '',
                    waiting_status: '',
                    center_class: {
                        id: '',
                        course_id: '',
                        name: ''
                    },
                    course: {
                        id: '',
                        name: '',
                        fee: '',
                        sale: '',
                    },
                }],
            },
            /* list variable */
            promotions: [],
            vouchers: [],
            center_classes: [],
            courses: [],
            /* list variable of contract */
            promotionForContract: '',
            vouchersForContract: [],
            condition_courses: [],
            showModalListCourses: false,
            is_transferred: false,
            totalPromotionAfterTransferred: 0,
            gift_select: [],
            is_edutalk: false,
            branchs: [],
            collapse_detail: true,
        }
    },
    computed: {
        remainingDebtAmount() {
            return (Number(this.totalPriceContract) || 0) - this.totalPaidAmount;
        },
        totalPaidAmount() {
            return (Number(this.contract.total_paid) || 0);
        },
        isShowWarrantySummary() {
            return isWarrantyServiceCenter(this.contract.center_id) && !!this.contract.service_id;
        },
        warrantyServiceAmount() {
            const serviceTotal = Number(this.contract.service_total);

            if (serviceTotal > 0) {
                return serviceTotal;
            }

            if (!this.contract.service) {
                return 0;
            }

            const total = Number(this.contract.total) || 0;
            const percent = Number(
                this.contract.service.percent_price != null
                    ? this.contract.service.percent_price
                    : this.contract.service.percent
            ) || 0;

            return (total * percent) / 100;
        },
        totalPriceContract() {
            return this.totalCourseRegisterFee - this.totalDiscount + this.totalDestroyFee + this.contract.service_total;
        },
        courseList() {
            const self = this;
            const destroy_fee = self.totalDestroyFee;
            const totalContract = this.totalCourseRegisterFee - this.totalDiscount + this.totalDestroyFee;
            const totalCourseFeeDiscount = this.contract_detail.student_register_courses.reduce((sum, item) => sum + item.course_fee_discount, 0);
            return this.contract_detail.student_register_courses.map(course_info => ({
                ...course_info,
                get course_fee_discount_proxy() {
                    if (totalCourseFeeDiscount !== totalContract) {
                        let percent = parseInt(course_info.course_fee) / self.totalCourseRegisterFee;
                        if (destroy_fee > 0) {
                            return parseInt(course_info.course_fee) - parseInt(percent * self.totalDiscount) + parseInt(percent * destroy_fee);
                        }
                        return parseInt(course_info.course_fee) - (percent) * self.totalDiscount;
                    } else {
                        return parseInt(course_info.course_fee_discount);
                    }
                },
                set course_fee_discount_proxy(val) {
                    course_info.course_fee_discount = val;
                }
            }));
        }
    },
    mounted() {
        this.clearForm();
    },
    watch: {
        showModal() {
            if (this.showModal) {
                this.title = "Thông tin chi tiết hợp đồng";
                this.$refs['modal-view-detail'].show();
                this.is_nap_rut_form = false;
                if (this.contract) {
                    this.gift_select = this.contract?.gift_select;
                    if (this.gift_select) {
                        this.gift_select.description = this.gift_select.description?.replace(/\n/g, '<br>');
                    }
                    this.listCourseRefund();
                    this.getCourses();
                    this.getClasses();
                    // set các giá trị cho việc hiển thị
                    this.contract_detail = this.contract;
                    this.getListBranch();
                    if (this.contract.center && this.contract.center.is_edutalk === 1) {
                        this.is_edutalk = true
                    }
                    this.contract_detail.user.profile.birthday = this.contract_detail.user.profile.birthday ?
                        this.contract_detail.user.profile.birthday.split("-").reverse().join("-") : '';
                    this.promotionForContract = this.contract.promotion ? this.contract.promotion : '';
                    this.vouchersForContract = this.contract.vouchers ? this.contract.vouchers : [];
                    this.id_voucher_disable = _.reduce(this.contract.vouchers, function (result, value, key) {
                        result.push(value.id);
                        return result
                    }, []);
                    this.id_promotion_disable = this.contract.promotion?.id | '';

                    this.refundData = this.contract_detail.log_refund.filter((item) => {
                        return item.type_refund === 4;
                    });
                    this.giftData = this.contract_detail.log_refund.filter((item) => {
                        return item.type_refund === 3;
                    });
                    this.contract_detail.user.profile.birthday = this.contract_detail.user.profile.birthday ?
                        this.contract_detail.user.profile.birthday.split("-").reverse().join("-") : '';
                    const subcontractsCourse = this.contract_detail.subcontracts.filter((item) => item.type === 1);
                    let arrCourse = [];
                    let courseWithDraw = subcontractsCourse.map(item => item.courses_relation).map(item => item.map(item => item.id));
                    courseWithDraw.forEach(item => {
                        item.forEach(value => arrCourse.push(value))
                    })
                    arrCourse = [...new Set(arrCourse)];
                    let courseInCourseStudent = [];
                    this.contract.student_register_courses.forEach((item) => {
                        if (arrCourse.includes(item.course_id)) {
                            courseInCourseStudent.push(item);
                        }
                    });
                    const subcontractsWithinCourse = this.contract_detail.subcontracts.filter((item) => item.type === 2);
                    this.totalCourseRefundFee = subcontractsCourse.reduce((result, subcontract) => result + subcontract.value, 0);

                    //chuyển nhượng
                    this.is_transferred = this.contract_detail.from_course_transfers.length > 0;
                    //nếu là chuyển nhượng
                    if (this.is_transferred) {
                        this.totalCourseRefundFee = courseInCourseStudent.reduce((result, item) => result + (item.course_fee * (100 - item.course_sale) / 100) - item.promotion_fee, 0);
                        this.totalPromotionAfterTransferred = this.contract_detail.total - this.contract_detail.total_after_voucher;
                    } else { // rút tiền bth
                        this.totalCourseRefundFee = courseInCourseStudent.reduce((result, item) => result + (item.course_fee * (100 - item.course_sale) / 100), 0);
                    }
                    this.totalDestroyFee = this.contract_detail.subcontracts.reduce((result, subcontract) => result + subcontract.destroy_fee, 0);
                    this.totalContractAmount = this.contract_detail.total_after_voucher - this.totalDestroyFee;
                    this.totalCourseRegisterFee = this.contract.student_register_courses.reduce((result, item) => {
                        return result + (item.course_fee * (100 - item.course_sale) / 100)
                    }, 0);
                    this.coursePrice = this.contract.student_register_courses.map((item) => item.course_fee);
                    this.promotionForContract = this.contract.vouchers.filter(item => item.type !== 0).shift();
                    let vouchersForContract = [];
                    if (this.promotionForContract) {
                        vouchersForContract.push(this.promotionForContract)
                    }
                    this.vouchersForContract = this.contract.vouchers.filter(item => item.type === 0);
                    this.contract.vouchers.filter(item => {
                        if (item.type === 0) {
                            vouchersForContract.push(item);
                        }
                    });
                    this.vouchersForContract = vouchersForContract;
                    this.calculateTotalValueForVoucher();
                    this.totalRootDiscount = this.totalCourseRegisterFee - this.totalContractAmount + this.contract_detail.service_total;
                    this.totalDiscount = this.totalRootDiscount;
                    this.condition_courses = _.reduce(this.contract.student_register_courses, function (result, value, key) {
                        result.push({
                            id: value.course.id,
                            name: value.course.name,
                            fee: value.course.fee,
                            sale: value.course.sale,
                        });
                        return result
                    }, []);
                }
            }
        },
    },
    methods: {
        onHide(evt) {
            this.$emit("clicked", true);
        },
        clearForm() {
            this.title = '';
        },
        hideViewModal() {
            this.$refs['modal-view-detail'].hide();
        },
        toggleModal() {
            // when the modal has hidden
            this.$refs['modal-view-detail'].toggle('#toggle-btn');
        },
        selectClass: function ($event) {
            console.log($event)
        },
        selectCourse: function ($event) {
            this.recalculate++;
        },
        openModalListCourses: function () {
            this.showModalListCourses = true;
        },
        closeModalListCourses: function () {
            this.showModalListCourses = false;
        },
        deleteCourse(index) {
            this.recalculate++;
            this.contract_detail.student_register_courses.splice(index, 1);
        },
        getClasses: function () {
            this.$store.dispatch(GET_CLASSES, {limit: 10000, status: 1}).then((res) => {
                this.center_classes = _.map(res.data.data, (item) => {
                    item = {id: item.id, name: item.name, course_id: item.course_id};
                    return item;
                })
            });
        },
        getCourses: function () {
            this.$store.dispatch(GET_COURSES, {
                limit: 10000,
                status: 1,
                center_id: this.center_id,
                all: 1
            }).then((res) => {
                this.courses = _.map(res.data, (item) => {
                    item = {id: item.id, name: item.name, fee: item.fee, sale: item.sale};
                    return item;
                })
            });
        },
        listCourseRefund: function () {
            this.$store.dispatch(LIST_COURSE_REFUND, {id: this.contract.id})
                .then((res) => {
                    this.coursesRefund = res.data;
                    this.isWithdrawWithCourse = this.coursesRefund.length > 0;
                });
        },
        changeChervon() {
            $('#button_show_value').children('.fas').toggleClass('fa-chevron-up fa-chevron-down');
        },
        changeChervonPromotion() {
            $('.button_show_value').children('.fas').toggleClass('fa-chevron-up fa-chevron-down');
        },
        calculateTotalValueForVoucher() {
            this.totalDiscountByVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 0) {
                    result += value.value;
                }
                return result;
            }, 0);
            this.totalValueOfVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 1) {
                    result += value.value;
                }
                return result;
            }, 0);
        },
        getListBranch() {
            this.$store.dispatch(GET_LIST_BRANCHES, {
                center_id: this.contract_detail.center_id,
            }).then((res) => {
                this.branchs = res.data;
                console.log(this.branchs, 'a')
            });
        }
    },

}
</script>

<style>
.list-courses {
    position: relative;
}

.delete-course {
    position: absolute;
    left: 5px;
    top: 38px;
    font-size: 10px;
    cursor: pointer;
    z-index: 10;
}

.promotion-img {
    width: 100%;
    height: 57px;
}

.promotion-icon {
    position: relative;
}

body .delete-promotion-contract {
    position: absolute;
    left: -35px;
    top: 0px !important;
    width: 26px;
    height: 26px;
}

.fa-minus-circle:hover {
    color: red !important;

}

.promotion-list {
    position: relative;
}

.promotion-count {
    position: absolute;
    background-color: red;
    border-radius: 50%;
    top: -7px;
    right: -17px;
    width: 16px;
    height: 16px;
    color: #fff;
    text-align: center;
}

.nap_rut_all_form .card-body {
    padding: 15px;
}

</style>
